<template>
    <div class="preview">
        <div :style="previewStyle">
            <VueDraggableResizable
                class="active" :draggable="true" :parent="true"
                :resizable="false" :w="width" :h="height" :x="axis_x" :y="axis_y" @dragstop="onDragged">
                <ResourceImg :id="copyright.resource" :rotate="copyright.rotate" :transparent="copyright.transparent"/>
            </VueDraggableResizable>
        </div>
        <FormModel :action="submit" :label-col="{span: 2}"
                   :model="copyright" :wrapper-col="{span: 22}" labelAlign="left" v-on="$listeners">
            <a-form-model-item label="尺寸">
                <a-slider :max="100" :min="20" :step="5" @change="refreshAxis" v-model="copyright.size_percent"/>
            </a-form-model-item>
            <a-form-model-item label="透明">
                <a-slider :max="100" :min="50" :step="5" v-model="copyright.transparent"/>
            </a-form-model-item>
            <a-form-model-item label="旋转">
                <a-slider :max="360" :min="0" :step="1" v-model="copyright.rotate"/>
            </a-form-model-item>
        </FormModel>
    </div>
</template>

<script>
    import api from "../../../../../utils/api";
    import cache from "../../../../../utils/cache";
    import FormModel from "../../../../../comps/FormModel";
    import ResourceImg from "../../../../../comps/ResourceImg";
    import VueDraggableResizable from 'vue-draggable-resizable';
    import func from "../../../../../utils/func";

    export default {
        name: "CopyrightForm",
        components: {FormModel, ResourceImg, VueDraggableResizable},
        props: {
            album: Object,
            preview: Object,
        },
        data() {
            return {
                copyright: {
                    axis_x: [],
                    axis_y: [],
                    rotate: 0,
                    resource: "",
                    size_percent: 100,
                    transparent: 100,
                    wh_ratio: 1,
                }
            }
        },
        computed: {
            width() {
                let size = this.copyright.wh_ratio >= this.previewPercent
                    ? this.preview.width : (this.preview.height * this.copyright.wh_ratio);
                return this.copyright.size_percent * size / 100;
            },
            height() {
                let size = this.copyright.wh_ratio >= this.previewPercent
                    ? (this.preview.width / this.copyright.wh_ratio) : this.preview.height;
                return this.copyright.size_percent * size / 100;
            },
            axis_x() {
                return this.copyright.axis_x[0] * this.preview.width;
            },
            axis_y() {
                return this.copyright.axis_y[0] * this.preview.height;
            },
            previewStyle() {
                let url = api.v1.resource.watermarkPreview(0);
                return `background:url(${url});width:${this.preview.width}px;height:${this.preview.height}px`;
            },
            previewPercent() {
                return this.preview.width / this.preview.height;
            }
        },
        mounted() {
            this.copyright = func.copyObject(this.album.copyright);
        },
        methods: {
            refreshAxis() {
                if ((this.axis_x + this.width > this.preview.width) || (this.axis_y + this.height) > this.preview.height)
                    this.onDragged(Math.min(this.axis_x, this.preview.width - this.width), Math.min(this.axis_y, this.preview.height - this.height))
            },
            onDragged(x, y) {
                this.copyright.axis_x = [
                    Math.min(1, x / this.preview.width),
                    Math.min(1, (x + this.width) / this.preview.width),
                ];
                this.copyright.axis_y = [
                    Math.min(1, y / this.preview.height),
                    Math.min(1, (y + this.height) / this.preview.height)
                ];
            },
            submit() {
                return cache.v1.album.setCopyright(this.album.id, this.copyright)
                    .then(() => this.album.copyright = this.copyright);
            },
        }
    }
</script>

<style scoped lang="less">
    .preview {
        padding: 5px 4px;
        overflow: hidden;
        position: relative;

        .vdr {
            cursor: pointer;
            border: 1px transparent solid;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .active {
            border-color: #ff5500;
        }

        .ant-form {
            margin-top: 15px;
        }
    }

    .ant-form-item {
        margin-bottom: 0;
    }
</style>
